import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { API_URL } from "@/config/api";

export const authClient = createAuthClient({
	baseURL: API_URL,
	credentials: "include",
	plugins: [adminClient()],
});
